import basicModules from './basicModules';
import userModules from './userModules';
import activeModules from './activeModules';

import { combineReducers } from 'redux';

export default combineReducers({
    basicModules: basicModules,
    userModules:userModules,
    activeModules: activeModules,
})
